import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = user
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        // Anonymous visitor: /auth/me returns 401 by design.
        setUser(false);
      } finally {
        setLoading(false);
      }
    })();
    // Runs once on mount to resolve the current session.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password, mfaCode) => {
    const { data } = await api.post("/auth/login", { email, password, mfa_code: mfaCode || undefined });
    setUser(data);
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (err) { /* logout is best-effort; clear session regardless */ }
    setUser(false);
  };

  const value = useMemo(() => ({ user, loading, login, register, logout }), [user, loading]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
